import { MessageModelType } from '../../types/Messenger/types'

export default {
  messages: (modelType: MessageModelType, modelId: number) => ['MESSAGES', modelType, Number(modelId)],
}
